// extracted by mini-css-extract-plugin
export default {"espacamento":"TextoMascara_espacamento__BfAwV","label":"TextoMascara_label__wM5ks"};